$(document).ready(function () {

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
});
    // Handle category button click
    $(".category-btn").click(function() {
      $(".category-modal").show();
    });
    
    // Handle modal close buttons
    $(".modal-close-btn").click(function() {
      $(this).closest(".modal-container").hide();
    });
    
    // Handle backdrop click to close modals
    $(".modal-backdrop").click(function() {
      $(this).closest(".modal-container").hide();
    });
    
    // Handle ESC key to close modals
    $(document).keydown(function(e) {
      if (e.key === "Escape") {
        $(".modal-container").hide();
      }
    });
   
    $('footer h2.font-heading').click(function(e){
        e.preventDefault();
        $(this).next().slideToggle();
        $(this).toggleClass('active');
    });
    if (!$('.recommended-products').hasClass('slick-initialized')) {
      $('.recommended-products').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        fade:true,
        infinite:false
      });
    }

  
    var initSlick = function() {
        var windowWidth = $(window).width();
        
        if (windowWidth <= 989) {
          // Only initialize if not already initialized
          if (!$('.blog-slider').hasClass('slick-initialized')) {
            $('.blog-slider').slick({
              centerMode: true,
              centerPadding: '60px',
              slidesToShow: 1,
              arrows: false,
              dots: false,
              autoplay: true,
              autoplaySpeed: 5000,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    centerPadding: '40px'
                  }
                }
              ]
            });
          }
        } else {
          // Destroy slick on desktop if it's initialized
          if ($('.blog-slider').hasClass('slick-initialized')) {
            $('.blog-slider').slick('unslick');
          }
        }
        
        if (windowWidth <= 989) {
         if (!$('.expandable-images-grid').hasClass('slick-initialized')) {
            $('.expandable-images-grid').slick({
              slidesToShow: 2,
              arrows: false,
              dots: true,
              autoplay: true,
              autoplaySpeed: 5000,
              responsive: [
                {
                  breakpoint: 640,
                  settings: {
                    slidesToShow: 1
                  }
                }
              ]
            });
          }
        } else {
          // Destroy slick on desktop if it's initialized
          if ($('.expandable-images-grid').hasClass('slick-initialized')) {
            $('.expandable-images-grid').slick('unslick');
          }
        }
        
        if (windowWidth <= 989) {
          // Only initialize if not already initialized
          if (!$('.related-slider').hasClass('slick-initialized')) {
            $('.related-slider').slick({
              slidesToShow: 2,
              arrows: false,
              dots: true,
              autoplay: false,
              responsive: [
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                  }
                }
              ]
            });
          }
        } else {
          // Destroy slick on desktop if it's initialized
          if ($('.related-slider').hasClass('slick-initialized')) {
            $('.related-slider').slick('unslick');
          }
        }

      if (windowWidth <= 600) {
          // Only initialize if not already initialized
          if (!$('.related-posts-slider').hasClass('slick-initialized')) {
            $('.related-posts-slider').slick({
              slidesToShow: 1,
              arrows: false,
              dots: true,
              autoplay: false,
              infinite:false
            });
          }
        } else {
          // Destroy slick on desktop if it's initialized
          if ($('.related-posts-slider').hasClass('slick-initialized')) {
            $('.related-posts-slider').slick('unslick');
          }
        }
    };
    
    // Initialize on page load with a slight delay to ensure all elements are properly rendered
    setTimeout(function() {
        initSlick();
    }, 100);
    
    // Handle resize events
    $(window).on('resize', function() {
      initSlick();
    });
    $('.shop-dropdown-menu ul li:last-child a').attr("href","/collections/all");

    function initUpsellSlider() {
    const $slider = $('.upsells-slider');

    if ($slider.length && !$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 5000,
            infinite:true,
            prevArrow: '<a href=":javascript;" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left size-6"><path d="m15 18-6-6 6-6"></path></svg></a>',
            nextArrow: '<a href=":javascript;" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right size-6"><path d="m9 18 6-6-6-6"></path></svg></a>',
            /*responsive: [
              {
                breakpoint: 480,
                settings: {
                  dots: true,
                  arrows: false,
                }
              }
              ]*/
        });
      } else if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    }

    initUpsellSlider();

    // Re-run after cart updates (Shopify AJAX themes often dispatch 'cart:updated')
  document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('cart:updated', function () {
      setTimeout(initUpsellSlider, 100); // delay a bit for DOM injection
    });
  });
  
  // Fallback: use mutation observer if no cart event
  const observer = new MutationObserver(function () {
    initUpsellSlider();
  });
  observer.observe(document.querySelector('body'), {
    childList: true,
    subtree: true
  });

/* ------------------------------------------------------------------
 * Testimonial video — YouTube modal trigger
 * Markup in: sections/testimonials-youtube-carousel.liquid
 *            snippets/testimonials-youtube-card.liquid
 * ------------------------------------------------------------------ */
(function () {
  function bmtOpenYoutubeModal(sectionId, videoId) {
    var modal = document.getElementById('bmt-youtube-modal-' + sectionId);
    if (!modal) return;
    var iframe = modal.querySelector('iframe');
    if (iframe && videoId) {
      iframe.src =
        'https://www.youtube.com/embed/' +
        encodeURIComponent(videoId) +
        '?autoplay=1&rel=0';
    }
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function bmtCloseYoutubeModal(modal) {
    if (!modal) return;
    var iframe = modal.querySelector('iframe');
    if (iframe) iframe.src = '';
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function bmtCloseAllYoutubeModals() {
    document
      .querySelectorAll('.bmt-youtube-modal.is-open')
      .forEach(function (m) {
        bmtCloseYoutubeModal(m);
      });
  }

  // Open
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.js-bmt-youtube-play');
    if (!trigger) return;
    e.preventDefault();
    var videoId = trigger.getAttribute('data-youtube-id');
    var sectionId = trigger.getAttribute('data-section-id');
    if (!videoId || !sectionId) return;
    bmtOpenYoutubeModal(sectionId, videoId);
  });

  // Close (backdrop or close button)
  document.addEventListener('click', function (e) {
    var closer = e.target.closest && e.target.closest('[data-bmt-youtube-close]');
    if (!closer) return;
    e.preventDefault();
    bmtCloseYoutubeModal(closer.closest('.bmt-youtube-modal'));
  });

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') bmtCloseAllYoutubeModals();
  });
})();



});